import { useLazyQuery } from '@apollo/client/react';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import {
  GetWebAppointmentForChargeDocument,
  WebAppointmentForChargeFragment,
} from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';
import { webVisitorChargeModalState } from '~/state/reception/atoms';

export const useFetchAppointment = (): WebAppointmentForChargeFragment | null => {
  const { isOpen, appointmentId } = useAtomValue(webVisitorChargeModalState);
  const [getAppointment, { data }] = useLazyQuery(GetWebAppointmentForChargeDocument);

  const appointment = getNode(data, 'Appointment') || null;

  useEffect(() => {
    if (isOpen && appointmentId) {
      getAppointment({ variables: { appointmentId } });
    }
  }, [appointmentId, getAppointment, isOpen]);

  return appointment;
};
